import React, { useState } from 'react';
import Header from './Components/Header';
import AccessControl from './Components/AccessControl';
import Main from './Components/Main';

function Provisionamento() {
  const [canAccess, setCanAccess] = useState(false);

  return (
    <>
      <Header />
      {
        !canAccess
            ? <AccessControl setCanAccess={(value) => setCanAccess(value)} /> 
            : <Main />
      }
    </>
  )
}

export default Provisionamento;